// This import loads the firebase namespace along with all its type information.
import Cast from './cast-model'

export async function load_casts(): Promise<Cast[]> {
  throw 'Not implemented'
}

export async function delete_cast(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_cast(): Promise<Cast> {
  throw 'Not implemented'
}
